import React from "react";
import { Grid, Typography, Paper, TextField, Button, Alert } from "@mui/material";
import LanguageSwitcher from "../../../utilities/LanguageSwitcher";
import { useTheme } from "@mui/material/styles";
import * as EmailValidator from "email-validator";
import AuthContext from "../../../contexts/AuthContext";
import { useTranslation } from "react-i18next";

import { forgot } from "../../../utilities/authFlow";

const Forgot = ({ setPage }) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const { email, setEmail, appStyle, appConfig } =
    React.useContext(AuthContext);
  const [error, setError] = React.useState("");
  const [goToPage, setGoToPage] = React.useState(null);

  const validateEmail = () => {
    console.log("validating email");
    const valid = EmailValidator.validate(email);
    if (!valid) {
      setError("Please enter a valid email");
      return false;
    }
    if (valid && error) {
      setError(null);
    }
    return true;
  };

  const renderGoToPage = () => {
    if (!goToPage) return null;
    if (goToPage === "signup") {
      return (
        <Button
          variant="outlined"
          style={{ width: 200 }}
          onClick={() => setPage("signup")}
        >
          Create Account
        </Button>
      );
    } else if (goToPage === "confirm") {
      return (
        <Button
          variant="outlined"
          style={{ width: 200 }}
          onClick={() => setPage("confirm")}
        >
          Confirm Account
        </Button>
      );
    } else {
      return null;
    }
  };

  const handleSendCode = async () => {
    if (!validateEmail()) {
      return;
    }
    if (error) {
      return;
    }

    try {
      const result = await forgot(email);
      if (result.success) {
        setPage("confirm-forgot");
      } else {
        setError(result.error);
        setGoToPage(result.page);
      }
    } catch (e) {
      var error = `Error requesting reset code. Error: ${e.message}`;
      console.error(error);
      setError(error);
    }
  };

  return (
    <Grid container justifyContent="center" spacing={3}>
      <Grid item xs={12} style={{ display: "flex", justifyContent: "center" }}>
        <img src={appStyle?.logo} height="175px" />
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
        lg={6}
        style={{ display: "flex", justifyContent: "center" }}
      >
        <form
          style={{ width: "100%", display: "flex", justifyContent: "center" }}
        >
          <Paper elevation={3} style={{ width: "90%", padding: 10 }}>
            <Grid container direction="column" spacing={3}>
              <Grid item style={{ marginTop: 20, marginBottom: 5 }}>
                <Typography variant="h5" align="center">
                  {t("auth.reset.title")}
                </Typography>
              </Grid>
              <Grid item style={{ marginTop: 5, marginBottom: 15 }}>
                <Typography variant="body1" align="center">
                  {t("auth.reset.instructions")}
                </Typography>
              </Grid>
              {error ? (
                <Grid
                  item
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: 20,
                  }}
                >
                  <Alert
                    severity="error"
                    sx={{
                      width: "90%",
                    }}
                  >
                    {error}
                  </Alert>
                  {renderGoToPage()}
                </Grid>
              ) : (
                <></>
              )}
              <Grid item style={{ display: "flex", justifyContent: "center" }}>
                <TextField
                  autoFocus
                  label={t("email.textbox.label")}
                  variant="outlined"
                  value={email}
                  onChange={(e) => setEmail(e.target.value.toLowerCase())}
                  onBlur={(e) => {
                    const trimmedEmail = e.target.value.trim().toLowerCase();
                    setEmail(trimmedEmail);
                  }}
                  // placeholder="Enter your email"
                  style={{ width: "90%" }}
                  sx={{
                    fieldset: { borderColor: "red" },
                  }}
                  autoComplete="off"
                />
              </Grid>

              <Grid item style={{ display: "flex", justifyContent: "center" }}>
                <Button
                  variant="contained"
                  style={{
                    width: "90%",
                    height: 40,
                    backgroundColor: theme.palette.primary.main,
                  }}
                  onClick={handleSendCode}
                >
                  {t("auth.reset.sendcode")}
                </Button>
              </Grid>
              <Grid item style={{ display: "flex", justifyContent: "center" }}>
                <Button
                  style={{
                    width: "90%",
                    height: 40,
                    color: theme.palette.primary.main,
                  }}
                  onClick={() => setPage("login")}
                >
                  {t("auth.backtologin.btn")}
                </Button>
              </Grid>
              <Grid item style={{ marginTop: 0, marginBottom: 0 }}>
                <Typography
                  variant="subtitle2"
                  align="center"
                  style={{ paddingLeft: 10, paddingRight: 10 }}
                >
                  {t("auth.havingtrouble.txt")}
                  <span
                    onClick={() => setPage("troubleshoot")}
                    style={{
                      color: theme.palette.primary.main,
                      cursor: "pointer",
                    }}
                  >
                    {t("auth.havingtrouble.link")}
                  </span>
                  .
                </Typography>
              </Grid>
            </Grid>
          </Paper>
        </form>
      </Grid>
      <Grid item xs={12}>
        <Grid container direction="column" spacing={2}>
          <Grid item>
            <Typography align="center" style={{ color: "#353535" }}>
              &copy; Aisle 2 LLC All Rights Reserved
            </Typography>
          </Grid>
          <Grid item>
            <Typography
              align="center"
              style={{ color: "#353535", cursor: "pointer" }}
              onClick={() => window.open(appConfig?.privacyPolicy, "_blank")}
            >
              {t("privacypolicy.link")}
            </Typography>
          </Grid>
          <Grid item style={{ marginBottom: 50 }}>
            <LanguageSwitcher />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Forgot;
